import type {
  ProductDetailsActionDTO,
  SavedAddressDTO,
  SavedCardDTO,
  UserListDTO,
} from '~gateways/ownable.dtos';
import type { JourneyParameters } from '~types/navigation';
import type { INavigationLeaf } from '~types/views-types';

export type ProductActionType =
  | ProductActions.brand
  | ProductActions.producttype
  | ProductActions.source;

enum ProductActions {
  producttype = 'producttype',
  brand = 'brand',
  source = 'source',
}

export type Token = {
  success: boolean;
  token: string;
  expires: string;
};
type IProductSummary = {
  id: number;
  brand: string;
  brandId: number;
  name: string;
  price: number;
  rrp?: number;
  priceLabel: string;
  featuredIn?: string;
  unit?: string | null;
  actions: IProductActions[];
  tooltip?: string;
  published?: boolean;
  postage?: number | null;
};
// the extended details of a product which are needed
// to be able to display the product detail with its
// various buy/save/share etc. buttons
export type IProductDetail = Omit<IProductSummary, 'brandId'> & {
  description: string;
  mediaUrls: string[];
  appearance?: IProductAppearance;
  options: IProductOption[];
  optionsLabel?: string;
};
export type IProductActions = ProductDetailsActionDTO & object;
// an appearance of a product in a magazine, including
// a destination object to be able to transition the
// view to that appearance
export type IProductAppearance = {
  displayName: string;
  destination: JourneyParameters;
};
// an option or variation for a given product,
// which may or may not have its own price and
// image (eg.. size: large, material: gold, etc)
export type IProductOption = {
  id: number;
  optionName: string;
  valueName?: string;
  default: boolean;
  price: number | null;
  imageUrl: string | null;
  rrp?: number;
};
export type UserSettings = {
  fullName: string;
  email: string;
  privacyConsent: boolean;
  savedAddresses: SavedAddressDTO[];
  savedCards: SavedCardDTO[];
};
// a logged-in user
export type IUser = {
  success: boolean;
  id: number;
  name: string;
  email: string;
  bearerToken: string;
  refreshToken: string;
  roles: string[];
};
export type IError = {
  success: boolean;
  errorCode: string;
  message: string;
};
export type UserLists = UserListDTO[];
export type INavigationNode = {
  id: string;
  name: string;
  children: (INavigationLeaf | INavigationNode)[];
  subTitle?: string | null;
  secondary?: boolean;
  action?: () => void;
};
export type OrderHistory = {
  id: number;
  orderNumber: string;
  created: string;
  status: string;
  deliveryRecipient: string;
  deliveryStreet: string;
  deliveryTownOrCity: string;
  deliveryCounty: string;
  deliveryPostcode: string;
  items: OrderHistoryItem[];
  deliveryCharge: number;
  paymentMethodDescription: string;
  orderTotal: number;
  orderSubTotal: number;
  cancelVerb: string;
};
type OrderHistoryItem = {
  id: number;
  productId: number;
  productName: string;
  productBrand: string;
  productOption: string;
  productPrice: number;
  quantity: number;
};
export type TCardType = 'amex' | 'maestro' | 'mastercard' | 'visa';

export enum Qty {
  add = 'add',
  minus = 'minus',
}
